import React from "react";
import { useNavigate } from "react-router-dom";
import { FaHome, FaArrowLeft } from "react-icons/fa";

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h1 style={styles.errorCode}>404</h1>

        <div style={styles.divider} />

        <h2 style={styles.title}>Page Not Found</h2>

        <p style={styles.message}>
          Sorry, the page you are looking for doesn't exist,
          has been moved, or the URL is incorrect.
        </p>

        <div style={styles.buttonGroup}>
          <button
            style={styles.homeButton}
            onClick={() => navigate("/")}
          >
            <FaHome />
            <span>Go to Home</span>
          </button>

          <button
            style={styles.backButton}
            onClick={() => navigate(-1)}
          >
            <FaArrowLeft />
            <span>Go Back</span>
          </button>
        </div>

        <p style={styles.footer}>
          Error Code: 404 | Page Not Found
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "24px",
    background: "#f5f7fb",
    fontFamily: "Arial, sans-serif",
    boxSizing: "border-box",
  },

  content: {
    width: "100%",
    maxWidth: "550px",
    textAlign: "center",
    padding: "45px 30px",
    background: "#ffffff",
    borderRadius: "16px",
    boxShadow: "0 8px 35px rgba(0, 0, 0, 0.07)",
  },

  errorCode: {
    fontSize: "clamp(90px, 18vw, 150px)",
    fontWeight: "800",
    lineHeight: "1",
    margin: "0",
    color: "#5b3cc4",
    letterSpacing: "-6px",
  },

  divider: {
    width: "70px",
    height: "5px",
    borderRadius: "5px",
    background: "#5b3cc4",
    margin: "24px auto",
  },

  title: {
    fontSize: "28px",
    fontWeight: "700",
    color: "#25233a",
    marginBottom: "12px",
  },

  message: {
    fontSize: "15px",
    lineHeight: "1.8",
    color: "#6b7280",
    margin: "0 auto 28px",
    maxWidth: "400px",
  },

  buttonGroup: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
  },

  homeButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "9px",
    padding: "13px 22px",
    border: "none",
    borderRadius: "8px",
    background: "#5b3cc4",
    color: "#ffffff",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
  },

  backButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "9px",
    padding: "12px 22px",
    border: "1px solid #d7d5e2",
    borderRadius: "8px",
    background: "#ffffff",
    color: "#514b68",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
  },

  footer: {
    marginTop: "32px",
    marginBottom: "0",
    fontSize: "12px",
    color: "#9ca3af",
  },
};